import { Accordion } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'

import type { Question, Section } from '../hooks/useFaqData'
import FaqQuestion from './FaqQuestion'
import FaqSection from './FaqSection'

export const FaqWrapper = ({
  faqData,
  trackFaqClick,
  shouldShowLargeHeader = false,
  ...props
}: {
  faqData: Section[]
  trackFaqClick: (uuid: Array<Question['uuid']>) => void
  shouldShowLargeHeader?: boolean
}) => {
  const { t } = useTranslation('@mc/next')

  return (
    <section
      {...props}
      id='faq'
      style={{ scrollMarginTop: 'var(--mc-scale-12)' }}
    >
      <h2
        className={`${
          shouldShowLargeHeader ? 'mc-text-h1' : 'mc-text-h2'
        }  mc-text--center`}
      >
        {t('faq.title.string')}
      </h2>
      <div className='row'>
        <div className='col-md-8 offset-md-2'>
          <Accordion onChange={trackFaqClick}>
            {faqData.map(({ title, questions }) => (
              <FaqSection key={title} title={title}>
                {questions.map(
                  ({ title: questionTitle, uuid, answer, hide }) =>
                    !hide && (
                      <FaqQuestion key={uuid} title={questionTitle} uuid={uuid}>
                        {answer}
                      </FaqQuestion>
                    ),
                )}
              </FaqSection>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  )
}
